import React from "react"
import types from "prop-types"
import WhitelistedUserEmailDescriptions from "./WhitelistedUserEmailDescriptions"

const OrganizationWhitelistedUserEmailDescriptions = ({ organization, whitelistedUserEmailDescriptions }) => (
  <>
    <h1 className="header-title">{organization.name}</h1>
    <div className="inner-container mx-auto max-w-screen-lg">
      <div className="side-tabs-container">
        <h2 className="tab-title">Domain Whitelist</h2>
        <p>The emails and/or domains below are the only ones permitted for users&apos; emails in this organization.</p>

        <WhitelistedUserEmailDescriptions
          organization={organization}
          whitelistedUserEmailDescriptions={whitelistedUserEmailDescriptions}
        />
      </div>
    </div>
  </>
)

OrganizationWhitelistedUserEmailDescriptions.propTypes = {
  organization: types.object.isRequired,
  whitelistedUserEmailDescriptions: types.arrayOf(types.object).isRequired,
}

export default OrganizationWhitelistedUserEmailDescriptions
